import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewShipments from './pages/NewShipments';
import LiveShipments from './pages/LiveShipments';
import AllShipments from './pages/AllShipments';
import Billing from './pages/Billing';
import Serviceability from './pages/Serviceability';
import Team from './pages/Team';
import Support from './pages/Support';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function AppContent() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="shipments/new" element={<NewShipments />} />
        <Route path="shipments/live" element={<LiveShipments />} />
        <Route path="shipments/all" element={<AllShipments />} />
        <Route path="billing" element={<Billing />} />
        <Route path="serviceability" element={<Serviceability />} />
        <Route path="team" element={<Team />} />
        <Route path="support" element={<Support />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
